import * as React from 'react';
const { useMemo } = React;

import { LeadsEntry } from '@leads';
import { StatusEntry } from '@status';

export const PartnersRoutes = {
	LEADS: 'leads',
	STATUS: 'status',
};

function createRoutes(matchUrl: string) {
	const routes = useMemo(() => [
		{
			path: `${matchUrl}/leads`,
			sysName: PartnersRoutes.LEADS,
			name: 'Заявки',
		},
		{
			path: `${matchUrl}/status`,
			sysName: PartnersRoutes.STATUS,
			name: 'Статус',
		},
	], [matchUrl]);

	return routes;
}

const componentsMap = {
	[PartnersRoutes.LEADS]: LeadsEntry,
	[PartnersRoutes.STATUS]: StatusEntry,
} as Record<string, React.ComponentType<{}>>;

export {
	createRoutes,
	componentsMap,
};
